import React from 'react';
import * as T from 'prop-types';
import { useFormState } from 'react-final-form';
import QuestionField from './QuestionField';
import { evaluateCondition } from './conditionUtil';

const FollowUpQuestion = QuestionField;

FollowUpQuestion.propTypes = {
    condition: T.object,
};

const Question = (props) => {
    const { question, prefix, projectCompanies } = props;
    const { values } = useFormState();
    return (
        <div>
            <QuestionField
                prefix={prefix}
                question={question}
                projectCompanies={projectCompanies}
            />
            <ol>
                <div style={{ margin: ' 0px 40px 40px 40px' }}>
                    {(question?.oversightFollowUpQuestionJoins ?? []).map(
                        // eslint-disable-next-line array-callback-return,consistent-return
                        (followUpQuestionJoin, index) => {
                            const followUpQuestion =
                                followUpQuestionJoin.oversightFollowUpQuestion;
                            if (
                                evaluateCondition(
                                    followUpQuestionJoin.condition,
                                    values
                                )
                            ) {
                                return (
                                    <li type="a" key={index}>
                                        <FollowUpQuestion
                                            question={followUpQuestion}
                                            condition={
                                                followUpQuestionJoin.condition
                                            }
                                            prefix={`${prefix}${question.qid}.f`}
                                            key={index}
                                            projectCompanies={projectCompanies}
                                        />
                                    </li>
                                );
                            }
                        }
                    )}
                </div>
            </ol>
        </div>
    );
};

Question.propTypes = {
    question: T.object,
    form: T.object,
    prefix: T.string,
    projectCompanies: T.string,
};

export default Question;
